import { useStatQuery } from '@famly/stat_use-stat-query';
import { StatPermissionsEmployee } from './stat-permissions-employee.query';
export function useStatPermissionsEmployeeQuery(options) {
    const queryResult = useStatQuery(StatPermissionsEmployee, options);
    // add cache updates here
    return queryResult;
}
